
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { translate } from '@/translations';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* About */}
          <div>
            <h3 className="text-xl font-serif mb-4 text-secondary">Dr. Victoria Neiman</h3>
            <p className="text-gray-300 mb-4">
              Leading oncologist providing personalized cancer care and treatment with cutting-edge medical expertise and compassion.
            </p>
            {/* <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">
                <span className="sr-only">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">
                <span className="sr-only">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.064-.926-2.064-2.064 0-1.138.92-2.063 2.064-2.063 1.14 0 2.064.925 2.064 2.063 0 1.138-.925 2.064-2.064 2.064zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-serif mb-4">{translate('quickLinks', language)}</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-secondary transition-colors">{translate('home', language)}</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-secondary transition-colors">{translate('about', language)}</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-secondary transition-colors">{translate('services', language)}</Link></li>
              {/* <li><Link to="/blog" className="text-gray-300 hover:text-secondary transition-colors">{translate('blog', language)}</Link></li> */}
              <li><Link to="/contact" className="text-gray-300 hover:text-secondary transition-colors">{translate('contact', language)}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-serif mb-4">{translate('contactInfo', language)}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="mt-1 flex-shrink-0 text-secondary" />
                <span className="text-gray-300">4 Mota Gur<br/>Petah Tikva, Israel</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={20} className="flex-shrink-0 text-secondary" />
                <span className="text-gray-300">073-702-1736</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={20} className="flex-shrink-0 text-secondary" />
                <span className="text-gray-300">victoria.neiman@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Office Hours */}
          <div>
            <h3 className="text-xl font-serif mb-4">{translate('officeHoursFooter', language)}</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-3">
                <Clock size={18} className="flex-shrink-0 text-secondary" />
                <div>
                  <p className="text-gray-300">Sunday - Thursday</p>
                  <p className="text-gray-400">9:00 AM - 5:00 PM</p>
                </div>
              </li>
              {/* <li className="flex items-center space-x-3">
                <Clock size={18} className="flex-shrink-0 text-secondary" />
                <div>
                  <p className="text-gray-300">Friday</p>
                  <p className="text-gray-400">9:00 AM - 2:00 PM</p>
                </div>
              </li> */}
              <li className="flex items-center space-x-3">
                <Clock size={18} className="flex-shrink-0 text-secondary" />
                <div>
                  <p className="text-gray-300">Friday - Saturday</p>
                  <p className="text-gray-400">Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 mb-4 md:mb-0">© {currentYear} Dr. Victoria Neiman. {translate('rights', language)}.</p>
            {/* <div className="flex space-x-6"> */}
              {/* <Link to="/privacy-policy" className="text-gray-400 hover:text-secondary transition-colors">{translate('privacyPolicy', language)}</Link> */}
              {/* <Link to="/terms" className="text-gray-400 hover:text-secondary transition-colors">{translate('termsOfService', language)}</Link> */}
              {/* Admin Login link removed */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
